export function isImperialInputEmpty(inputGroupSelector) {
  return Array.from(inputGroupSelector.querySelectorAll('select')).every(select => select.value === '');
}
